module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Edit-58d80e88f01e0a69ac3fbb55a56cefcd.svg";